// extracted by mini-css-extract-plugin
export default {"aboutme":"Aboutme_aboutme__VkaxZ","about":"Aboutme_about__r0mMZ","Emoji":"Aboutme_Emoji__evKuf","floating":"Aboutme_floating__sI1Cy"};